import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';

import { AfterLoginRedirect } from 'src/providers/auth/afterLoginRedirect';
import { Auth } from 'src/providers/auth/auth';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';

// Customers reach /past-job/<id> from links to a job they already have. Signed out,
// they must sign in to the account that owns it, then land on that job: a guest account
// made from the welcome screen can never open it (the API answers 403).
@Injectable({
  providedIn: 'root'
})
export class PastJobLinkGuard implements CanActivate {

  private afterLoginRedirect = inject(AfterLoginRedirect);
  private auth = inject(Auth);
  private navCtrl = inject(CustomNavController);

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (this.auth.isAuthenticated()) {
      return true;
    }
    this.afterLoginRedirect.pendingPastJobId = String(route.params.cleaningId);
    this.navCtrl.navigateRoot('login');
    return false;
  }
}
